import * as React from 'react';
import { connect } from 'react-redux';
import { StepContainer } from '@ane/ui-components/lib/components/StepContainer';
import { CreateStepTitle } from '../CreateWizard/CreateSteps';
import { FormHeading } from '@ane/ui-components/lib/components/FormHeading';
import { FormSection } from '@ane/ui-components/lib/components/FormSection';
import { DataProfilingChoiceGroupComponent } from './DataProfilingChoiceGroupComponent';
export var ProfilingOptions;
(function (ProfilingOptions) {
    ProfilingOptions["Manual"] = "Manual";
    ProfilingOptions["Daily"] = "Daily";
    ProfilingOptions["Weekly"] = "Weekly";
})(ProfilingOptions || (ProfilingOptions = {}));
const mapStateToProps = (state, props) => { };
const mapDispatchToProps = {};
export class DataProfilingComponent extends React.Component {
    render() {
        return (React.createElement(StepContainer, null,
            React.createElement(FormHeading, { pageTitle: CreateStepTitle.Profiling },
                "In this section, we seek your consent to profile a subset of columns in your data source to ensure that these columns do not cause any downstream issues with scorecard generation. If you provide us your consent, we will run a test profiling job and notify you about its cost. You will then have the option to modify the frequency of profiling, which is set to manual by default. If we determine any additional columns need profiling, we will seek your consent to profile, and if granted, determine cost and notify you. At each such instance, you can update the frequency of profiling as desired.",
                React.createElement("br", null),
                React.createElement("br", null),
                "We strongly recommend that you provide us your consent. If you do not, Azure Experimentation Studio will be unable to detect data issues beforehand, that may lead to scorecard failures."),
            React.createElement(FormSection, null,
                React.createElement(DataProfilingChoiceGroupComponent, { isEnableProfiling: this.props.isEnableProfiling, isReadOnly: !!this.props.isReadOnly }))));
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(DataProfilingComponent);

//# sourceMappingURL=DataProfilingComponent.js.map
